@if (schedule) {
  <article class="theme4d23">
    <header>
      <section class="info">
        <div>
          <label>Schedule</label>
          <a [routerLink]="['/setpoints', 'templates', schedule.template.id, 'scheduler', schedule.id]" title="Edit the schedule"><i class="mdi mdi-square-edit-outline"></i> {{ schedule.title }}</a>
        </div>
        <div>
          <label>Template</label>
          <a [routerLink]="['/setpoints', 'templates', schedule.template.id]" title="Edit the template" tooltipPosition="left"
            ><i class="mdi mdi-square-edit-outline"></i>
            {{ schedule.template.title }}
          </a>
          <small class="chip" title="Category">{{ schedule.template.category.title }}</small>
        </div>
        <div>
          <label>Process&nbsp;Date</label>
          {{ schedule.processAt | date: 'dd-MM-yy' }}
        </div>
      </section>
      <section class="counts">
        <div title="There are {{ assetCount }} assets attached to this schedule" tooltipPosition="top">
          <label>Assets</label>
          {{ assetCount | number: '1.0' : 'en-GB' }}
        </div>
        <div title="There are {{ alarmCount }} out of 4 rag's toggled (red/amber min/max)" tooltipPosition="top">
          <label>Alarms in template</label>
          {{ alarmCount }}
        </div>
        <div title="There are {{ dayCount }} out of 7 days enabled" tooltipPosition="top">
          <label>Days in template</label>
          {{ dayCount }}
        </div>
        <div title="Generate {{ alarmCount }} x {{ dayCount }} x {{ assetCount }} alarms" tooltipPosition="top">
          <label>Total Alarms</label>
          {{ ruleCount | number: '1.0' : 'en-GB' }}
        </div>
      </section>
    </header>
    <main>
      <section>
        <h3>Assets</h3>
        <table class="table">
          <thead>
            <tr>
              <th>Site</th>
              <th>Gateway</th>
              <th>
                Asset
                @if (schedule.filter?.asset) {
                  <small title="asset must match this" tooltipPosition="top" class="chip">{{ schedule.filter.asset.op === '=' ? 'contains' : 'not' }} {{ schedule.filter.asset.value }}</small>
                }
              </th>
              <th>
                Location
                @if (schedule.filter?.location) {
                  <small title="Location must match this" tooltipPosition="top" class="chip">{{ schedule.filter.location.op === '=' ? 'contains' : 'not' }} {{ schedule.filter.location.value }}</small>
                }
              </th>
            </tr>
          </thead>
          <tbody>
            @for (asset of schedule.wouldProcess?.assets; track asset) {
              <tr>
                <td>{{ asset.gateway.site.title }}</td>
                <td>{{ asset.gateway.title }}</td>
                <td>{{ asset.title }}</td>
                <td>{{ asset.location }}</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    </main>
    <footer></footer>
  </article>
}
